import React from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Button,
  Copy
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import { useModal } from 'hooks'
import { IConvention } from 'services/NGT/Convention'
import { COLORS, FORMAT, SPACING } from 'utils'

interface ITableSearchConventions {
  page: number
  setPage: (page: number) => void
  totalItems: number
  rowsPerPage: number
  setRowsPerPage: (page: number) => void
  tableData: IConvention[]
  handleViewContractModal: (_contractId: number) => void
  handleEditConvention: (convention) => void
  handleDeleteConvention: (convention) => void
}
export const TableSearchConventions: React.FC<ITableSearchConventions> = ({
  tableData,
  handleEditConvention,
  handleDeleteConvention,
  page,
  setPage,
  handleViewContractModal,
  totalItems,
  rowsPerPage,
  setRowsPerPage
}) => {
  const { showModal } = useModal()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px" align="left"></TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Contrato
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled minwidth="50px">Fornecedor</TableCellStyled>
              <TableCellStyled minwidth="50px">Competência</TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Data Início
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Data Fim
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Vencido
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Qtd. Dias
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="left">
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.length > 0 &&
              tableData?.map((row, index) => (
                <TableRowStyled key={`${index}-${row.cdContrato}`}>
                  <TableCellStyled align="left">
                    <Copy
                      valueToCopy={row.cdContrato}
                      title="Copiar código de contrato"
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Button
                      text={row.cdContrato}
                      textColor={COLORS.blueFonts}
                      variantButton="text"
                      onClick={() => handleViewContractModal(row.idContrato)}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.documento(row.cnpjFornecedor)}
                  </TableCellStyled>
                  <TableCellStyled>{row.nmFornecedor}</TableCellStyled>
                  <TableCellStyled>
                    {FORMAT.competencia(row.nuAnoMesCompetencia)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row.dtVigenciaInicio)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row.dtVigenciaFim)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.flVencido ? 'Sim' : 'Não'}
                  </TableCellStyled>
                  <TableCellStyled align="left">{row.qtdDias}</TableCellStyled>
                  <TableCellStyled align="center">
                    <EditIcon
                      onClick={() => handleEditConvention(row)}
                      cursor="pointer"
                      marginRight={SPACING.spacing10}
                    />
                    <DeleteIcon
                      onClick={() =>
                        showModal({
                          handleConfirm: () =>
                            handleDeleteConvention(row.idAcordoConvencao),
                          message: 'Confirma exclusão (S/N)?',
                          txtButtonCancel: 'NÃO',
                          txtButtonConfirm: 'SIM',
                          type: 'alert'
                        })
                      }
                      cursor="pointer"
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
